module.exports = __webpack_public_path__ + "static/img/template_img.83662e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/template_img.jpg
// module id = 392
// module chunks = 0